import React from 'react';
import styles from './Header.module.scss';
import { GlobalHeader, GlobalHeaderProps } from '@eventbrite/consumer-header.global-header';
import { useAppContext } from '@/components/_shared/context/AppContext';

interface HeaderProps {
  isConsumerHeaderNewBffEnabled?: boolean;
  globalHeaderProps?: GlobalHeaderProps;
}

export const Header: React.FC<HeaderProps> = ({ isConsumerHeaderNewBffEnabled = false, globalHeaderProps }) => {
  const { data } = useAppContext();

  return (
    <div className={styles.wrapper} data-testid="header">
      <div className={styles.content}>
        <GlobalHeader
          env={{
            ...globalHeaderProps?.env,
            serverUrl: data.serverUrl,
          }}
          request={{ path: '/e/' }}
          isHomePage={false}
          disableFetchUser={!isConsumerHeaderNewBffEnabled}
          useConsumerHeaderBff={isConsumerHeaderNewBffEnabled}
        />
      </div>
    </div>
  );
};
